<section class="discard-changes-dialog">
  @if (!usesDynamicDialogHeader()) {
    <header class="discard-changes-dialog__header">
      <h2 class="discard-changes-dialog__title" [id]="titleId()">{{ title() }}</h2>
    </header>
  }

  <p class="discard-changes-dialog__message">{{ message() }}</p>

  <footer class="discard-changes-dialog__actions">
    <button pButton type="button" severity="secondary" [outlined]="true" (click)="cancel()">
      {{ cancelLabel() }}
    </button>

    <button pButton type="button" severity="danger" (click)="confirm()">
      {{ confirmLabel() }}
    </button>
  </footer>
</section>
